import { library, dom } from '@fortawesome/fontawesome-svg-core';
// Solid icons
import {
  faCheck,
  faSearch,
  faLink,
  faPlayCircle,
  faHome,
  faCalendarAlt,
  faReplyAll,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faRss,
  faArrowRight,
  faQuoteLeft,
  faAngleRight,
  faFilePdf,
  faMobileAlt,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faMagnifyingGlass,
  faLinkSlash,
  faPhone,
  faPenToSquare,
  faPaperPlane,
  faEye,
  faMobileScreen,
  faArrowUpRightFromSquare,
  faGem,
  faStar,
  faTowerObservation,
  faTable,
  faUniversity,
  faMapMarkedAlt,
  faSearchDollar,
  faFileInvoiceDollar,
  faExchangeAlt,
  faHandshake,
  faCubes,
  faTools,
  faUser,
  faUsers,
  faUserShield,
  faCogs,
  faCircleXmark,
  faSignInAlt,
  faSignOutAlt,
  faChartLine,
  faBuilding,
  faTrophy,
  faCheckToSlot,
  faPersonDigging,
  faPersonCircleCheck,
  faFlagCheckered,
  faRectangleList,
  faHand,
  faCancel,
  faCircleQuestion,
  faNetworkWired,
  faShieldAlt,
  faBrain,
  faGraduationCap,
  faBolt,
  faCalculator,
  faBullhorn,
  faComments,
  faClock,
  faExpandArrowsAlt,
  faBullseye,
  faPuzzlePiece,
  faExpand,
  faTag,
  faInbox,
  faMap,
  faFileContract,
  faBook,
  faCheckCircle,
  faArchive,
  faCirclePlus,
  faUserPlus,
  faList,
  faChevronLeft,
  faGlobe,
  faBug,
  faFloppyDisk,
  faTriangleExclamation,
  faDatabase,
  faEdit,
  faQuestionCircle,
  faUserSecret,
  faInfoCircle,
  faClockRotateLeft,
  faBan,
  faSackDollar,
  faHandHoldingUsd,
  faListCheck,
  faCircleInfo,
  faExclamationTriangle,
  faPeopleArrows,
  faPersonBooth,
  faUserCircle,
  faDollarSign,
  faBinoculars,
  faRandom,
  faStreetView,
  faGaugeHigh,
  faPeopleRoof,
  faCircleDot,
  faUpload,
  faFile,
  faCommentSlash,
  faListAlt,
  faAddressCard,
  faFileAlt,
  faTableList,
  faClipboardList,
  faEyeSlash,
  faDownload,
  faSync,
  faMoneyBill1Wave,
  faNewspaper,
  faServer,
  faFolderTree,
  faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
// Regular icons
import {
  faEnvelope,
  faEnvelopeOpen,
  faCalendar,
  faClipboard,
  faThumbsUp,
} from '@fortawesome/free-regular-svg-icons';
// Brand icons
import {
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faVimeoV,
  faYoutube,
  faInstagram,
  faStumbleupon,
  faLastfm,
  faPinterestP,
  faDribbble,
  faSkype,
  faWordpressSimple,
  faDelicious,
  faBehance,
  faDropbox,
  faSoundcloud,
  faDeviantart,
  faYahoo,
  faFlickr,
  faDigg,
  faTumblr,
  faGithub,
  faAmazon,
  faXing,
  faWikipediaW,
  faAndroid,
  faApple,
  faGooglePlusG,
  faTwitter,
  faWindows,
  faGoogle,
  faSearchengin,
} from '@fortawesome/free-brands-svg-icons';

// Add the imported icons to the library
// Solid
library.add(
  faCheck,
  faSearch,
  faLink,
  faPlayCircle,
  faHome,
  faCalendarAlt,
  faReplyAll,
  faLongArrowAltRight,
  faLongArrowAltLeft,
  faRss,
  faArrowRight,
  faQuoteLeft,
  faAngleRight,
  faFilePdf,
  faMobileAlt,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faMagnifyingGlass,
  faLinkSlash,
  faPhone,
  faPenToSquare,
  faPaperPlane,
  faEye,
  faMobileScreen,
  faArrowUpRightFromSquare,
  faGem,
  faStar,
  faTowerObservation,
  faTable,
  faUniversity,
  faMapMarkedAlt,
  faSearchDollar,
  faFileInvoiceDollar,
  faExchangeAlt,
  faHandshake,
  faCubes,
  faTools,
  faUser,
  faUsers,
  faUserShield,
  faCogs,
  faCircleXmark,
  faSignInAlt,
  faSignOutAlt,
  faChartLine,
  faBuilding,
  faTrophy,
  faCheckToSlot,
  faPersonDigging,
  faPersonCircleCheck,
  faFlagCheckered,
  faRectangleList,
  faHand,
  faCancel,
  faCircleQuestion,
  faShieldAlt,
  faBrain,
  faNetworkWired,
  faGraduationCap,
  faBolt,
  faCalculator,
  faBullhorn,
  faComments,
  faClock,
  faExpandArrowsAlt,
  faBullseye,
  faPuzzlePiece,
  faExpand,
  faTag,
  faInbox,
  faMap,
  faFileContract,
  faBook,
  faCheckCircle,
  faArchive,
  faCirclePlus,
  faUserPlus,
  faList,
  faChevronLeft,
  faGlobe,
  faBug,
  faFloppyDisk,
  faTriangleExclamation,
  faDatabase,
  faEdit,
  faQuestionCircle,
  faUserSecret,
  faInfoCircle,
  faClockRotateLeft,
  faBan,
  faSackDollar,
  faHandHoldingUsd,
  faListCheck,
  faCircleInfo,
  faExclamationTriangle,
  faPeopleArrows,
  faPersonBooth,
  faUserCircle,
  faDollarSign,
  faBinoculars,
  faRandom,
  faStreetView,
  faGaugeHigh,
  faPeopleRoof,
  faCircleDot,
  faUpload,
  faFile,
  faCommentSlash,
  faListAlt,
  faAddressCard,
  faFileAlt,
  faTableList,
  faClipboardList,
  faEyeSlash,
  faDownload,
  faSync,
  faMoneyBill1Wave,
  faNewspaper,
  faServer,
  faFolderTree,
  faExternalLinkAlt,
);
// Regular
library.add(faEnvelope, faEnvelopeOpen, faCalendar, faClipboard, faThumbsUp);
// Brands
library.add(
  faFacebookF,
  faXTwitter,
  faLinkedinIn,
  faVimeoV,
  faYoutube,
  faInstagram,
  faStumbleupon,
  faLastfm,
  faPinterestP,
  faDribbble,
  faSkype,
  faWordpressSimple,
  faDelicious,
  faBehance,
  faDropbox,
  faSoundcloud,
  faDeviantart,
  faYahoo,
  faFlickr,
  faDigg,
  faTumblr,
  faGithub,
  faAmazon,
  faXing,
  faWikipediaW,
  faAndroid,
  faApple,
  faGooglePlusG,
  faTwitter,
  faWindows,
  faGoogle,
  faSearchengin
);

// Tell FontAwesome to watch the DOM and add the SVGs when it detects icon usage
dom.watch();
